<template>
  <v-app>
    <!-- <iframe src="https://calendar.google.com/calendar/embed?src=m.helmy%40brandifygroup.net&ctz=Africa%2FCairo" style="border: 0" width="800" height="600" frameborder="0" scrolling="no"></iframe> -->
    <v-container fluid style="margin-top: 0%; padding: 0% 0% 0 0; ">
      <v-row dense style=" overflow: hidden; margin: 0; padding: 0; position: relative">
        <v-col cols="12" class="pa-0">
          <GlobalNav />
        </v-col>
        <v-col cols="12" class="pa-0 d-flex align-start ga-6">
          <SideBar />
          <div class="w-100 pa-3 is-light-mode">
            <BreadCrumb :linksData="linksData" class="mb-3" />
            <div class="add-task mt-5">
              <div class="d-flex align-center ga-2">
                <span class="today-style">
                  {{
                    today.toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                    })
                  }}
                </span>
                <span class="vuetify-date-input-icon cursor-pointer">
                  <v-date-input hide-details variant="plain" prepend-icon="" prepend-inner-icon="$calendar"
                    density="compact" format="YYYY-MM-DD" v-model="today">
                    <template v-slot:text-field="{ value }">
                      <v-text-field :model-value="formatDate(value)" readonly variant="plain"></v-text-field>
                    </template>
                  </v-date-input>
                </span>
              </div>
              <a :disabled="!$permissionsFor('leads-managment').update"
                :class="{ 'read-only': !$permissionsFor('leads-managment').update }"
                @click="this.$router.push('/create-task')">Add
                Task</a>
            </div>

            <v-row class="" dense style="min-height: 75rem">
              <v-col cols="12">
                <v-sheet class="calendar-container">
                  <v-calendar ref="calendar" v-model="today" :events="events" color="primary" :view-mode="viewMode">
                    <template v-slot:event="{ event }">

                      <div v-if="viewMode === 'month'" @click="showEvent(event)" :class="[
                        'event-content cursor-pointer d-flex align-center justify-space-between',
                        event.color === '#F6DDDD'
                          ? 'urgent-event'
                          : event.color === '#FFF5E9'
                            ? 'high-event'
                            : event.color === '#DEEEFF'
                              ? 'normal-event'
                              : event.color === '#53647114'
                                ? 'low-event'
                                : '',
                      ]">
                        <span class="text-nowrap">{{
                          event.title.length > 20
                            ? event.title.slice(0, 10) + "..."
                            : event.title
                        }}</span>
                        <span>{{ formatEventTime(event.start) }}</span>
                      </div>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-col>

              <v-dialog v-model="selectedOpen" max-width="500">
                <v-card v-if="selectedEvent">
                  <v-card-text>
                    <div class="d-flex justify-space-between align-center">
                      <span class="d-flex align-center ga-3">
                        <span class="cursor-pointer" @click="
                          this.$router.push({
                            name: 'CalenderTaskShow',
                            params: { id: selectedEvent.id },
                          })
                          ">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M0.833984 9.99967C0.833984 9.99967 4.16732 3.33301 10.0007 3.33301C15.834 3.33301 19.1673 9.99967 19.1673 9.99967C19.1673 9.99967 15.834 16.6663 10.0007 16.6663C4.16732 16.6663 0.833984 9.99967 0.833984 9.99967Z"
                              stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M10.0007 12.4997C11.3814 12.4997 12.5006 11.3804 12.5006 9.99967C12.5006 8.61896 11.3814 7.49967 10.0007 7.49967C8.61994 7.49967 7.50065 8.61896 7.50065 9.99967C7.50065 11.3804 8.61994 12.4997 10.0007 12.4997Z"
                              stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span class="cursor-pointer" :disabled="!$permissionsFor('leads-managment').update"
                          :class="{ 'read-only': !$permissionsFor('leads-managment').update }" @click="
                            this.$router.push({
                              name: 'CalenderTaskEdit',
                              params: { id: selectedEvent.id },
                            })
                            ">

                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_5386_91413)">
                              <path
                                d="M7.33398 2.66714H2.66732C2.3137 2.66714 1.97456 2.80762 1.72451 3.05767C1.47446 3.30772 1.33398 3.64685 1.33398 4.00048V13.3338C1.33398 13.6874 1.47446 14.0266 1.72451 14.2766C1.97456 14.5267 2.3137 14.6671 2.66732 14.6671H12.0007C12.3543 14.6671 12.6934 14.5267 12.9435 14.2766C13.1935 14.0266 13.334 13.6874 13.334 13.3338V8.66714M12.334 1.66714C12.5992 1.40193 12.9589 1.25293 13.334 1.25293C13.7091 1.25293 14.0688 1.40193 14.334 1.66714C14.5992 1.93236 14.7482 2.29207 14.7482 2.66714C14.7482 3.04222 14.5992 3.40193 14.334 3.66714L8.00065 10.0005L5.33398 10.6671L6.00065 8.00048L12.334 1.66714Z"
                                stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_5386_91413">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>

                        <span class="cursor-pointer" @click="askToDelete(selectedEvent.id)"
                          :disabled="!$permissionsFor('leads-managment').update"
                          :class="{ 'read-only': !$permissionsFor('leads-managment').update }">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_5386_91414)">
                              <path
                                d="M13.0822 1.84188H9.86654V1.41553C9.86611 1.04023 9.71683 0.680416 9.45144 0.415042C9.18605 0.149669 8.82623 0.000405281 8.45093 0H5.54921C5.17392 0.00042699 4.81412 0.1497 4.54875 0.415071C4.28338 0.680442 4.1341 1.04024 4.13368 1.41553V1.84188H0.917969C0.809189 1.84188 0.704864 1.88509 0.627944 1.96201C0.551025 2.03893 0.507813 2.14325 0.507812 2.25203C0.507813 2.36081 0.551025 2.46514 0.627944 2.54206C0.704864 2.61897 0.809189 2.66219 0.917969 2.66219H1.49705V11.5052C1.49777 12.1666 1.76083 12.8007 2.22852 13.2684C2.69621 13.7362 3.33033 13.9992 3.99176 14H10.0084C10.6698 13.9992 11.3039 13.7362 11.7716 13.2685C12.2393 12.8008 12.5024 12.1667 12.5031 11.5053V2.66219H13.0822C13.1909 2.66219 13.2953 2.61897 13.3722 2.54206C13.4491 2.46514 13.4923 2.36081 13.4923 2.25203C13.4923 2.14325 13.4491 2.03893 13.3722 1.96201C13.2953 1.88509 13.1909 1.84188 13.0822 1.84188ZM4.95399 1.41553C4.95417 1.25773 5.01694 1.10643 5.12852 0.994848C5.24011 0.883262 5.3914 0.820493 5.54921 0.820312H8.45093C8.60873 0.820493 8.76002 0.883262 8.87161 0.994848C8.9832 1.10643 9.04596 1.25773 9.04614 1.41553V1.84188H4.95399V1.41553ZM11.6828 11.5054C11.6823 11.9493 11.5057 12.3749 11.1918 12.6887C10.8779 13.0026 10.4523 13.1792 10.0084 13.1797H3.99176C3.54784 13.1792 3.12224 13.0026 2.80834 12.6887C2.49443 12.3748 2.31787 11.9492 2.31737 11.5053V2.66219H11.6828V11.5054ZM6.58991 10.7935V4.40751C6.58991 4.29873 6.63312 4.19441 6.71004 4.11749C6.78696 4.04057 6.89129 3.99736 7.00007 3.99736C7.10885 3.99736 7.21317 4.04057 7.29009 4.11749C7.36701 4.19441 7.41022 4.29873 7.41022 4.40751V10.7935C7.41022 10.9023 7.36701 11.0066 7.29009 11.0836C7.21317 11.1605 7.10885 11.2037 7.00007 11.2037C6.89129 11.2037 6.78696 11.1605 6.71004 11.0836C6.63312 11.0066 6.58991 10.9023 6.58991 10.7935ZM9.41203 10.086V5.11506C9.41203 5.00628 9.45524 4.90195 9.53216 4.82503C9.60908 4.74812 9.71341 4.7049 9.82219 4.7049C9.93097 4.7049 10.0353 4.74812 10.1122 4.82503C10.1891 4.90195 10.2323 5.00628 10.2323 5.11506V10.086C10.2323 10.1947 10.1891 10.2991 10.1122 10.376C10.0353 10.4529 9.93097 10.4961 9.82219 10.4961C9.71341 10.4961 9.60908 10.4529 9.53216 10.376C9.45524 10.2991 9.41203 10.1947 9.41203 10.086ZM3.76779 10.086V5.11506C3.76779 5.00628 3.811 4.90195 3.88792 4.82503C3.96484 4.74812 4.06917 4.7049 4.17795 4.7049C4.28673 4.7049 4.39105 4.74812 4.46797 4.82503C4.54489 4.90195 4.5881 5.00628 4.5881 5.11506V10.086C4.5881 10.1947 4.54489 10.2991 4.46797 10.376C4.39105 10.4529 4.28673 10.4961 4.17795 10.4961C4.06917 10.4961 3.96484 10.4529 3.88792 10.376C3.811 10.2991 3.76779 10.1947 3.76779 10.086Z"
                                fill="#666666" />
                            </g>
                            <defs>
                              <clipPath id="clip0_5386_91414">
                                <rect width="14" height="14" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </span>
                      <span class="cursor-pointer" @click="selectedOpen = false">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 3L3 9M3 3L9 9" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                    </div>
                    <div class="d-flex flex-column ga-3 mt-5">
                      <div class="d-flex ga-3 align-center">
                        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.97182 4.3623L4.83984 4.49428V10.7887C4.83984 16.4672 4.84661 17.0899 4.89399 17.1373C4.9346 17.1813 5.02597 17.1914 5.317 17.1914C5.66556 17.1914 5.69264 17.188 5.77047 17.1068L5.85507 17.0256V14.5383V12.0544L6.10211 11.963C6.23409 11.9122 6.39314 11.8412 6.44729 11.8107C6.50482 11.7769 6.72478 11.7024 6.93798 11.6415C7.15118 11.584 7.3813 11.5129 7.4456 11.4892C7.63172 11.4181 7.87199 11.3708 8.29162 11.3166C8.68418 11.2692 9.61819 11.2523 9.81108 11.2895L9.91599 11.3098V11.7667C9.91599 12.1525 9.92614 12.2405 9.98367 12.3522C10.0717 12.5281 10.136 12.5653 10.5759 12.7075C10.7823 12.7718 10.9786 12.8428 11.0158 12.8665C11.097 12.9139 11.1952 12.9376 11.7265 13.0425C12.3153 13.1609 12.9346 13.2117 13.449 13.1846C14.0886 13.1508 14.9177 12.9985 15.1106 12.8801C15.1478 12.8564 15.2629 12.809 15.3644 12.7752C15.5776 12.7075 16.3898 12.2946 16.4777 12.2134C16.5116 12.1829 16.586 12.1322 16.647 12.1017C16.7045 12.0713 16.8229 11.9799 16.9041 11.8987C17.053 11.7565 17.0564 11.7532 17.0564 11.5298C17.0564 11.32 17.009 11.1339 16.9549 11.1339C16.9414 11.1339 16.894 11.1 16.8466 11.056C16.8026 11.0154 16.7045 10.9376 16.63 10.8801C16.2172 10.5721 15.097 9.53997 15.0226 9.40122C14.9955 9.35046 15.0158 9.30985 15.1241 9.19479C15.317 8.99174 15.625 8.60596 15.7535 8.40968C15.8145 8.31493 15.8991 8.20325 15.9363 8.15587C15.9769 8.11188 16.048 7.99682 16.0953 7.90207C16.1427 7.81069 16.2036 7.70917 16.2273 7.6821C16.251 7.65503 16.3356 7.50951 16.4134 7.36061C16.4913 7.21171 16.5691 7.07296 16.5827 7.05604C16.5996 7.03574 16.6774 6.853 16.762 6.64995C16.8466 6.44352 16.9448 6.20325 16.9854 6.11526C17.0361 5.99344 17.0564 5.88176 17.0564 5.68548C17.0564 5.45198 17.0463 5.40799 16.982 5.34369C16.8568 5.22525 16.7079 5.14403 16.6097 5.14403C16.5082 5.14403 16.0514 5.31662 15.8889 5.41476C15.8348 5.4486 15.6046 5.53997 15.3813 5.62119C15.1579 5.69902 14.8906 5.79377 14.7891 5.82762C14.5928 5.89868 14.2916 5.96298 13.7908 6.0442C13.625 6.07127 13.4118 6.1085 13.317 6.12542C13.1173 6.15926 12.4101 6.16603 12.1596 6.13895L11.9803 6.11526V5.62795C11.9803 5.0019 11.9701 4.97821 11.5945 4.80562C11.2019 4.62626 10.3322 4.37245 9.78062 4.28108C9.39145 4.2134 8.1055 4.2134 7.73324 4.2777C7.30685 4.35553 6.43375 4.62288 6.26116 4.73455C6.21379 4.76163 6.1055 4.81916 6.01751 4.86315L5.85507 4.9376V4.75824C5.85507 4.60934 5.83815 4.5552 5.75017 4.44691C5.61142 4.26755 5.53358 4.23371 5.30008 4.23032C5.11396 4.23032 5.09365 4.23709 4.97182 4.3623Z"
                            :fill="selectedEvent.color === '#F6DDDD'
                              ? '#fa0000'
                              : selectedEvent.color === '#FFF5E9'
                                ? '#fc8a00'
                                : selectedEvent.color === '#DEEEFF'
                                  ? '#007bff'
                                  : selectedEvent.color === '#53647114'
                                    ? '#536471'
                                    : ''
                              " />
                        </svg>
                        <span class="task-title">{{
                          selectedEvent.title
                        }}</span>
                      </div>
                      <div class="d-flex ga-3 align-center task-date">
                        <span>{{ formatDate(selectedEvent.start) }} -
                          {{ formatDate(selectedEvent.end) }}</span>
                      </div>
                      <div class="d-flex ga-3 align-center">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.0423 0.341857C5.18105 0.534751 3.60745 1.25556 2.32487 2.50429C1.10998 3.68534 0.392555 5.06267 0.0812183 6.81901C-0.0270728 7.43154 -0.0270728 8.57536 0.0812183 9.18788C0.382403 10.8732 1.03892 12.1862 2.1692 13.3469C3.15736 14.3622 4.35195 15.0661 5.68528 15.418C6.45008 15.6177 6.83587 15.665 7.66836 15.665C8.50085 15.665 8.88663 15.6177 9.65144 15.418C11.7462 14.8664 13.5601 13.3875 14.5313 11.4349C14.8866 10.7276 15.0998 10.0576 15.2555 9.18788C15.3198 8.83255 15.3299 8.63966 15.3299 8.00345C15.3299 7.36724 15.3198 7.17435 15.2555 6.81901C14.9543 5.13374 14.2978 3.82071 13.1675 2.65996C11.7327 1.18111 9.8714 0.375698 7.82064 0.338473C7.4687 0.331705 7.11675 0.335089 7.0423 0.341857ZM8.33841 1.57705C10.8765 1.85116 13.022 3.58044 13.8071 5.98314C14.7445 8.83932 13.5838 11.973 11.0152 13.5331C8.47377 15.0728 5.20474 14.6735 3.09983 12.572C0.575296 10.0441 0.575296 5.96284 3.09983 3.43492C4.47716 2.06098 6.4264 1.36724 8.33841 1.57705Z"
                            fill="#666666" />
                          <path
                            d="M7.10752 3.36755C6.04153 3.51984 5.12444 3.96992 4.37994 4.70765C3.73696 5.34725 3.33087 6.08498 3.11429 7.01222C3.02968 7.36755 3.01953 7.47584 3.01953 8.00376C3.01953 8.53168 3.02968 8.63997 3.11429 8.9953C3.16505 9.21527 3.24288 9.49276 3.29026 9.61121C4.12613 11.8413 6.49838 13.1036 8.76911 12.5351C9.62867 12.3185 10.3326 11.9225 10.9552 11.3033C11.5982 10.667 12.0077 9.91916 12.2243 8.9953C12.3089 8.63997 12.319 8.53168 12.319 8.00376C12.319 7.47584 12.3089 7.36755 12.2243 7.01222C12.0077 6.08498 11.6016 5.34725 10.9586 4.70765C10.0889 3.84471 9.01953 3.38447 7.80464 3.35063C7.53391 3.34386 7.22258 3.35063 7.10752 3.36755ZM8.5999 4.32864C9.24965 4.49446 9.98738 4.92762 10.4205 5.39801C10.8469 5.85825 11.1887 6.47415 11.3478 7.07314C11.429 7.37771 11.4358 7.46908 11.4358 8.00376C11.4358 8.53845 11.429 8.62982 11.3478 8.93439C11.1718 9.5909 10.742 10.3253 10.275 10.755C9.81479 11.1814 9.19889 11.5232 8.5999 11.6823C8.29533 11.7635 8.20396 11.7703 7.66928 11.7703C7.13459 11.7703 7.04322 11.7635 6.73865 11.6823C6.13967 11.5232 5.52376 11.1814 5.06352 10.755C4.59652 10.3253 4.16674 9.5909 3.99077 8.93439C3.90955 8.62982 3.90278 8.53845 3.90278 8.00376C3.90278 7.46908 3.90955 7.37771 3.99077 7.07314C4.14982 6.47415 4.49161 5.85825 4.91801 5.39801C5.44593 4.8261 6.31226 4.37263 7.1109 4.24742C7.47638 4.19327 8.22088 4.2305 8.5999 4.32864Z"
                            fill="#666666" />
                        </svg>
                        <span class="d-flex align-center ga-2">
                          <span :style="{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor:
                              selectedEvent.color === '#F6DDDD'
                                ? '#fa0000'
                                : selectedEvent.color === '#FFF5E9'
                                  ? '#fc8a00'
                                  : selectedEvent.color === '#DEEEFF'
                                    ? '#007bff'
                                    : selectedEvent.color === '#53647114'
                                      ? '#536471'
                                      : '',
                          }" class="task-dot">
                          </span>
                          <span class="task-status">{{ selectedEvent.status }}
                          </span>
                        </span>
                      </div>
                      <div class="d-flex ga-3 align-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.30695 3.13044C7.70289 3.38425 6.38648 4.58899 5.96685 6.18966C5.84841 6.63975 5.81795 7.49254 5.90594 7.97647C6.1056 9.0966 6.76888 10.1084 7.70627 10.7176L7.99731 10.9071L7.74011 11.0018C7.11067 11.2286 6.40001 11.6516 5.82133 12.1389C4.77565 13.0222 4.01761 14.3149 3.73673 15.699C3.62844 16.2337 3.6149 16.5653 3.69951 16.6939C3.8078 16.8597 3.95331 16.9274 4.17328 16.9105C4.34587 16.9003 4.38648 16.8834 4.488 16.7819C4.59629 16.6736 4.60983 16.6364 4.6572 16.325C4.75873 15.6381 4.90086 15.1744 5.17835 14.6194C5.93639 13.1034 7.28665 12.0678 8.96854 11.7057C9.26973 11.6381 9.42539 11.6279 10.0007 11.6279C10.576 11.6279 10.7317 11.6381 11.0328 11.7057C12.7114 12.0678 14.065 13.1068 14.8129 14.6025C15.1005 15.1711 15.2427 15.6313 15.3442 16.3183C15.3746 16.5145 15.4186 16.6804 15.4559 16.7311C15.6487 16.9985 16.1157 16.9782 16.3019 16.6939C16.3865 16.5653 16.3729 16.2337 16.2647 15.699C15.9939 14.3724 15.2833 13.1237 14.2816 12.2269C13.7198 11.7227 12.9279 11.2421 12.2613 11.0018L12.0041 10.9071L12.2951 10.7176C13.2325 10.1084 13.8958 9.0966 14.0954 7.97647C14.1834 7.48916 14.153 6.64313 14.0345 6.1829C13.6149 4.58222 12.2782 3.37071 10.6606 3.12706C10.268 3.06953 9.69274 3.06953 9.30695 3.13044ZM10.8264 4.19305C11.3577 4.34872 11.7943 4.60591 12.1936 4.99846C13.2866 6.07461 13.4626 7.68543 12.6267 8.95447C12.1936 9.61098 11.5337 10.0848 10.7587 10.2946C10.5252 10.3555 10.3865 10.3724 10.0007 10.3724C9.46262 10.3724 9.1479 10.3047 8.71135 10.1017C7.47616 9.53315 6.71135 8.2032 6.86702 6.91048C6.95839 6.16936 7.26634 5.53315 7.79088 5.01538C8.26126 4.55176 8.74181 4.2878 9.37463 4.14567C9.70289 4.07122 10.4982 4.09829 10.8264 4.19305Z"
                            fill="#666666" />
                        </svg>

                        <span>
                          <div class="event-assignees">
                            <v-avatar v-for="assignee in selectedEvent.assignees" :key="assignee.id" size="24"
                              class="mr-1">
                              <v-img :src="assignee.image" />
                            </v-avatar>
                          </div>
                        </span>
                      </div>
                      <div class="d-flex ga-3 align-center">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.8331 0H3.17311C1.42243 0 0.00312622 1.42243 0 3.17311V10.6198C0.00312622 12.3705 1.42243 13.7929 3.17311 13.7929H5.80539L7.53106 15.7593C7.75928 16.0188 8.15318 16.0438 8.41266 15.8155C8.43454 15.7968 8.4533 15.778 8.46893 15.7593L10.1946 13.7929H12.8269C14.5776 13.7898 15.9969 12.3705 16 10.6198V3.17311C16.0031 1.4193 14.5838 0 12.8331 0ZM14.7558 10.6166C14.7558 11.6796 13.8929 12.5393 12.8331 12.5393H9.91637C9.73818 12.5393 9.56623 12.6174 9.44744 12.7519L8.00312 14.3962L6.56194 12.7519C6.44314 12.6174 6.2712 12.5393 6.093 12.5393H3.17624C2.11332 12.5393 1.25361 11.6764 1.25049 10.6166V3.17311C1.25049 2.1102 2.11332 1.25049 3.17311 1.25049H12.8331C13.8929 1.25361 14.7526 2.11332 14.7558 3.17311V10.6166Z"
                            fill="#666666" />
                          <path
                            d="M11.9162 3.16699H4.08813C3.74425 3.16699 3.46289 3.44835 3.46289 3.79224C3.46289 4.13612 3.74425 4.41748 4.08813 4.41748H11.9162C12.2601 4.41748 12.5414 4.13612 12.5414 3.79224C12.5414 3.44835 12.2601 3.16699 11.9162 3.16699Z"
                            fill="#666666" />
                          <path
                            d="M11.9162 6.23047H4.08813C3.74425 6.23047 3.46289 6.51183 3.46289 6.85571C3.46289 7.1996 3.74425 7.48096 4.08813 7.48096H11.9162C12.2601 7.48096 12.5414 7.1996 12.5414 6.85571C12.5414 6.51183 12.2601 6.23047 11.9162 6.23047Z"
                            fill="#666666" />
                          <path
                            d="M11.9162 9.29395H4.08813C3.74425 9.29395 3.46289 9.57531 3.46289 9.91919C3.46289 10.2631 3.74425 10.5444 4.08813 10.5444H11.9162C12.2601 10.5444 12.5414 10.2631 12.5414 9.91919C12.5414 9.57531 12.2601 9.29395 11.9162 9.29395Z"
                            fill="#666666" />
                        </svg>

                        <span>{{ selectedEvent.description }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            <!-- <div style="height: 200px" class="w-100"></div> -->
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <v-dialog v-model="deleteDialog" width="auto">
    <v-card max-width="550">
      <template v-slot:text>
        <div>
          <div class="d-flex justify-space-between align-center mb-8">
            <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="4.5" width="48" height="48" rx="24" fill="#FEE4E2" />
              <rect x="4" y="4.5" width="48" height="48" rx="24" stroke="#FEF3F2" stroke-width="8" />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg @click="deleteDialog = false" width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" class="cursor-pointer hoverd">
              <path d="M18 6L6 18M6 6L18 18" stroke="#717680" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div class="delete-dialog-body">
            <div class="main mb-2">
              Are you sure you want to delete this item
            </div>
            <div class="sub">
              If you deleted this item you won’t be able to restore it again
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="pa-4 d-flex align-center ga-3">
          <v-btn class="cancel-btn" text="Cancel" @click="deleteDialog = false"></v-btn>
          <v-btn class="delete-btn text-capitalize" color="white" text="Delete" @click="deleteEvent"></v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import "@/assets/css/calender/style.css";
import { VCalendar } from "vuetify/labs/VCalendar";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";
import { VDateInput } from "vuetify/labs/VDateInput";
export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    VCalendar,
    VDateInput,
  },

  data() {
    return {
      linksData: [
        { name: "Home", link: "/" },
        { name: "Your Calendar", link: "" },
      ],
      today: new Date(),
      events: [],
      selectedEvent: null,
      selectedOpen: false,
      general_store: useGeneralStore(),
      deleteDialog: false,
      deleteId: null,
      viewMode: "month",
    };
  },
  methods: {
    adjustDateToCurrentMonth(dateString) {
      const date = new Date(dateString);
      const currentDate = new Date();
      date.setFullYear(currentDate.getFullYear());
      date.setMonth(currentDate.getMonth());
      return date;
    },

    formatDate(date) {
      return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      }).format(date);
    },

    formatEventTime(date) {
      return new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
      }).format(date);
    },

    showEvent(e) {
      this.selectedEvent = e;
      this.selectedOpen = true;
    },

    isEventStart(event) {
      if (!event || !event.start) return false;
      const eventDate = new Date(event.start);
      const eventStart = new Date(event.start);
      return eventDate.getDate() === eventStart.getDate();
    },

    isEventMiddle(event) {
      if (!event || !event.start || !event.end) return false;
      const eventDate = new Date();
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);
      return eventDate > eventStart && eventDate < eventEnd;
    },

    isEventEnd(event) {
      if (!event || !event.end) return false;
      const eventDate = new Date();
      const eventEnd = new Date(event.end);
      return eventDate.getDate() === eventEnd.getDate();
    },

    transformEvents() {
      this.events = this.events
        .map((event) => {
          if (!event.time || !event.time.start || !event.time.end) {
            console.warn("Invalid event data:", event);
            return null;
          }
          return {
            id: event.id,
            name: event.title,
            start: new Date(event.time.start),
            end: new Date(event.time.end),
            color: event.color,
            timed: true,
            title: event.title,
            description: event.description,
            status: event.status,
            priority: event.priority,
            tags: event.tags,
            with: event.with,
            assignees: event.assignes || [],
          };
        })
        .filter((event) => event !== null);
    },
    getEvents() {
      apiClient
        .get(`/calender/tasks`)
        .then((response) => {
          console.log(response);

          this.events = response.data.data.data;
          this.transformEvents();
          console.log(this.events);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    askToDelete(id) {
      this.deleteDialog = true;
      this.selectedOpen = false;
      this.deleteId = id;
    },
    deleteEvent() {
      apiClient
        .get(`/calender/delete/tasks/${this.deleteId}`)
        .then((response) => {
          console.log(response);
          this.selectedOpen = false;
          this.deleteId = null;
          this.deleteDialog = false;
          this.general_store?.showSnackbar("Event has been deleted", "#237276");
          this.getEvents();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getEvents();
  },
};
</script>

<style scoped>
.event-content {
  height: 28px;
  padding: 4px;
  border-radius: 3px;
  margin: 5px;
}

.low-event {
  background-color: #53647114;
  color: #536471;
}

.normal-event {
  background-color: #deeeff;
  color: #007bff;
}

.high-event {
  background-color: #fff5e9;
  color: #fc8a00;
}

.urgent-event {
  background-color: #f6dddd;
  color: #fa0000;
}

.task-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: #1a1a1a;
}

.task-date {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666666;
}

.task-status {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
</style>
